import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PAGE } from 'src/app/routes';
import { InitService } from '../services/init/init.service';

export const initialisedGuard: CanActivateFn = async () => {
  const initService = inject(InitService);
  const router = inject(Router);

  if (initService.initialised()) {
    return true;
  } else {
    router.navigate([PAGE.LOADING]);
    return false;
  }
};
